import { useQuery } from 'react-query'

import { getExpenseLineItemFormDataUseCase } from '@webapp/modules/expense/business-logic/use-cases/GetExpenseLineItemFormDataUseCase'
import {
  ExpenseFormReimbursementCustomizations,
  type ExpenseFormReimbursementCustomization,
} from '@webapp/modules/expense/entities/enums'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'
import { type ExpenseMileageConfiguration } from '../../entities'
import { useGetExpenseMileageConfigurationPresenter } from '../../features/get-expense-mileage-configuration'

interface UseEditExpenseLineItemDrawerParams {
  requesterId: number
}

interface UseEditExpenseLineItemDrawerReturn {
  data: {
    reimbursementSetting: ExpenseFormReimbursementCustomization
    mileageConfiguration: Nullable<ExpenseMileageConfiguration>
  }
  states: {
    isFormDataLoading: boolean
  }
}

export const useEditExpenseLineItemDrawer = ({
  requesterId,
}: UseEditExpenseLineItemDrawerParams): UseEditExpenseLineItemDrawerReturn => {
  const { data, isLoading: isFormDataLoading } = useQuery({
    queryKey: expenseReportQueryConfig.lineItemFormData(requesterId).queryKey,
    queryFn: () =>
      getExpenseLineItemFormDataUseCase.execute({ userId: requesterId }),
  })

  const {
    data: { configuration: mileageConfiguration },
    states: { isLoading: isMileageConfigurationLoading },
  } = useGetExpenseMileageConfigurationPresenter()

  const reimbursementSetting =
    data?.reimbursementSetting ??
    ExpenseFormReimbursementCustomizations.DEFAULT_YES

  return {
    data: {
      reimbursementSetting,
      mileageConfiguration,
    },
    states: {
      isFormDataLoading: isFormDataLoading || isMileageConfigurationLoading,
    },
  }
}
